<div class="top-section">
  <h3> Ports </h3>
</div>
<section class="rate-request rate-request-sec">
  <div class="middle-section">
    <div class="container">
      <div class="rate-request-form">
        <div class="rate-request-form-inner">
          <div class="pRel">
            <p-dropdown [options]="regions" optionLabel="regionName" [(ngModel)]="selectedRegion" (onChange)="onChangeRegion()" placeholder="Region" [virtualScroll]="true" [itemSize]="31" [filter]="false" class="p-dropdown"></p-dropdown>
          </div>
          <div class="countries pRel">
            <p-dropdown [options]="countries" optionLabel="countryName" [(ngModel)]="selectedCountry" (onChange)="onChangeCountry()" placeholder="Country" [virtualScroll]="true" [itemSize]="31" [filter]="false" class="p-dropdown"></p-dropdown>
          </div>
          <div class="pRel">
            <p-dropdown [options]="portStatus" optionLabel="viewValue" [(ngModel)]="selectedPortStatus" (onChange)="onChangePortStatus()" placeholder="Activation Status" [virtualScroll]="true" [itemSize]="31"  [filter]="false" class="p-dropdown"></p-dropdown>
          </div>
          <div class="request-btn">
            <input type="text" class="form-control" pInputText size="50" placeholder="Search" (change)="filterSearch($event.target.value)">
            <div class="btn-search">
              <button class="btn  btn-go my-2 my-sm-0" type="submit">
                <img src="../../../assets/images/Group 103.svg">
              </button>
            </div>
          </div>
        </div>
        <div class="rate-request-form-innera text-end mb-3">
          <a class="btn btn-signIn" (click)="openPortModal(0, 'add')">
            <i class="fa fa-plus"></i> Add Port </a>
        </div>
        <div class="table-responsive rate-request-tbl">
          <p-table [value]="portData">
            <ng-template pTemplate="header">
              <tr>
                <th>Port Name</th>
                <th>UN Code</th>
                <th>Country Name</th>
                <th>Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-port>
              <tr>
                <td>{{ port.portName }}</td>
                <td>{{ port.portCode }}</td>
                <td>{{ port.countryName }}</td>
                <td>
                  <a class="action-btn " tooltipPosition="top" pTooltip="Add Alias" data-toggle="modal" data-target=".add-modal" (click)="openAliasModal(port.id)">
                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18px" height="18px" fill="#505d6b">
                      <path d="M 7.5 1 C 3.917969 1 1 3.917969 1 7.5 C 1 11.082031 3.917969 14 7.5 14 C 11.082031 14 14 11.082031 14 7.5 C 14 3.917969 11.082031 1 7.5 1 Z M 7.5 2 C 10.542969 2 13 4.457031 13 7.5 C 13 10.542969 10.542969 13 7.5 13 C 4.457031 13 2 10.542969 2 7.5 C 2 4.457031 4.457031 2 7.5 2 Z M 7 4 L 7 7 L 4 7 L 4 8 L 7 8 L 7 11 L 8 11 L 8 8 L 11 8 L 11 7 L 8 7 L 8 4 Z" />
                    </svg>
                  </a>
                  <a class="action-btn text-success" tooltipPosition="top" pTooltip="View Alias" data-toggle="modal" data-target=".view-addaliases" (click)="openAliasModalView(port.id, port.portName)">
                    <i class="fa fa-eye"></i>
                  </a>
                  <!-- <a class="action-btn " tooltipPosition="top" pTooltip="Edit port"
                                        data-toggle="modal" data-target=".view-offredrate"
                                        (click)="getPortdetails(port.id,'edit')"><i class="fa fa-edit"></i></a> -->
                  <a class="action-btn" tooltipPosition="top" pTooltip="Edit port" (click)="openPortModal(port.id, 'edit')">
                    <i class="fa fa-edit"></i>
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <p-paginator *ngIf="totalcount > 0" [rows]="requestVM.pageSize" [rowsPerPageOptions]="[5,10,20]" [totalRecords]="totalcount" (onPageChange)="paginate($event)"></p-paginator>
        <div *ngIf="totalcount == 0">
          <span>No records found</span>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- Edit Port PopUp -->
<ng-template #portModal let-modal>
  <div class="modal-header">
    <h3>{{ portModalMode === 'add' ? 'Add Port' : 'Edit Port' }}</h3>
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <form [formGroup]="PortForm">
    <div class="modal-body">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-md-4 form-group">
            <label class="custom-labal "> Port Name </label>
            <input type="text" class="form-control" formControlName="portName" [ngClass]="{ 'is-invalid':(submitted && f.portName.errors) || ( f.portName.errors && f.portName.touched) || (f.portName.errors && f.portName.dirty)}" />
            <div *ngIf="(submitted && f.portName.errors) || ( f.portName.errors && f.portName.touched) || (f.portName.errors && f.portName.dirty)" class="invalid-feedback">
              <div class="port-error " *ngIf="f.portName.errors.required"> Port Name is required</div>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="custom-labal "> UN Code </label>
            <input type="text" class="form-control" formControlName="portCode" *ngIf="PortId > 0" disabled />
            <input type="text" class="form-control" formControlName="portCode" [ngClass]="{ 'is-invalid':(submitted && f.portCode.errors) || ( f.portCode.errors && f.portCode.touched) || (f.portCode.errors && f.portCode.dirty)}" *ngIf="PortId == 0" (change)="checkDuplicateUNCode()" />
            <div *ngIf="(submitted && f.portCode.errors) || ( f.portCode.errors && f.portCode.touched) || (f.portCode.errors && f.portCode.dirty)" class="invalid-feedback">
              <div class="port-error " *ngIf="f.portCode.errors.required"> UN Code is required </div>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="custom-labal "> Country Name </label>
            <p-dropdown [options]="countriesList" [disabled]="PortId > 0" optionLabel="countryName" formControlName="portCountryId" class="select-dropdown-sec" placeholder="Select Country" [virtualScroll]="true" [itemSize]="31"  [filter]="false"></p-dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 form-group">
            <label class="custom-labal "> Activate </label>
            <p-inputSwitch class="form-control" formControlName="isPortCallRegister"></p-inputSwitch>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="addPort()" class="btn btn-signIn" *ngIf="PortId == 0">Save</button>
      <button type="button" (click)="updateport()" class="btn btn-signIn" *ngIf="PortId > 0">Update</button>
    </div>
  </form>
</ng-template>

<!-- Add Port Alias PopUp -->
<ng-template #aliasModal let-modal>
  <div class="modal-header">
    <h3>{{ PortAliasId === 0 ? 'Add Alias' : 'Edit Alias' }}</h3>
    <button type="button" class="close-btn" (click)="modal.dismiss()" aria-label="Close">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <form [formGroup]="PortAlias" (ngSubmit)="AddPortAlias()">
    <div class="row ps-3 pb-3">
      <div class="col-md-4 form-group">
        <input type="hidden" class="form-control" formControlName="portId" />
        <input type="hidden" class="form-control" formControlName="id" />
        <label class="custom-labal "> Port Alias </label>
        <input type="text" class="form-control" formControlName="portaliasesName" [ngClass]="{ 'is-invalid':(submitted && fg.portaliasesName.errors) || ( fg.portaliasesName.errors && fg.portaliasesName.touched) || (fg.portaliasesName.errors && fg.portaliasesName.dirty)}" />
        <div *ngIf="(submitted && fg.portaliasesName.errors) || ( fg.portaliasesName.errors && fg.portaliasesName.touched) || (fg.portaliasesName.errors && fg.portaliasesName.dirty)" class="invalid-feedback">
          <div class="port-error " *ngIf="fg.portaliasesName.errors.required"> Port Alias is required</div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-signIn">Save</button>
    </div>
  </form>
</ng-template>

<!-- View Port Alias -->
<ng-template #viewAliasModal let-modal>
  <div class="modal-header">
    <h3>Port Alias List</h3>
    <button type="button" class="close-btn" (click)="modal.dismiss()" aria-label="Close">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <div class="modal-body borderTop mt-3">
    <div class="table-responsive rate-request-tbl">
      <p-table [value]="portAliasList">
        <ng-template pTemplate="header">
          <tr>
            <th>PortAlias Name</th>
            <th>Port Name</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-port>
          <tr>
            <td>{{port.portAliasName}}</td>
            <td>{{portName}}</td>
            <td>
              <a class="action-btn " tooltipPosition="top" pTooltip="Edit port alias" data-toggle="modal" data-target=".add-modal" (click)="getPortAliasDetails(port.id, port.portId)">
                <i class="fa fa-edit"></i>
              </a>
              <a class="action-btn" tooltipPosition="top" pTooltip="Delete port alias" (click)="deletePortAlias(port.id, port.portId)">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div style="text-align: center;" *ngIf="! portAliasList?.length"> No Record found </div>
  </div>
</ng-template>